import React from "react";
import styled from "styled-components";

import Button from "@mui/material/Button";
// import InputAddress from 'react-thailand-address-autocomplete'
// import InputLabel from '@mui/material/InputLabel'
// import MenuItem from '@mui/material/MenuItem'
// import FormControl from '@mui/material/FormControl'
// import FormHelperText from '@mui/material/FormHelperText'

// import Select from '@mui/material/Select'
// import Avatar from 'material-ui/Avatar'
// import Grid from '@mui/material/Grid'
// import GoogleMapReact from 'google-map-react'
// import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded'
// import { getCustomerTypeList, getCustomerDetail } from '../../api/customer'
// import UploadImage from '../dropzone/UploadImage'
// import { GoogleMap, useLoadScript, MarkerF } from '@react-google-maps/api'

const Modal = styled.div`
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const WrapperModal = styled.div`
  max-width: 880px;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 30px 25px;
  min-width: 444px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;

const WrapperModalInside = styled.div`
  width: auto;
  height: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-top: 100px;
  margin-bottom: 100px;
  margin-left: 150px;
  margin-right: 150px;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const DivTextUploadPhoto = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 1.25rem;
  margin-top: 15px;
  margin-bottom: 40px;
`;

function ModalAlert({ visible, onSave, close, title, id }) {
  const closeModal = () => {
    // setIsVisible(false)
    close(false);
  };

  return (
    <Modal>
      <WrapperModal>
        {/* <DivHead>
          <DivTitleHead>{"Alert"}</DivTitleHead>
          <CloseIcon
            sx={{ color: "rgba(0, 0, 0, 0.54)", cursor: "pointer" }}
            onClick={() => closeModal(false)}
          />
        </DivHead> */}
        <WrapperModalInside>
          <DivTextUploadPhoto>
            สินค้าของคุณได้ถูกบันทึกไปยังระบบ กรุณารอแอดมินตรวจสอบภายใน 48
            ชั่วโมง
          </DivTextUploadPhoto>
        </WrapperModalInside>
        <Button
          onClick={() => closeModal(false)}
          className="Button-New-Brand"
          style={{
            background: "#e04132",
            color: "#fff",
            borderRadius: "16px",
            margin: "auto",
            display: "flex",
            width: "64px",
            height: "42px",
          }}
        >
          ปิด
        </Button>
      </WrapperModal>
    </Modal>
  );
}

export default ModalAlert;
